import { forEach, isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import Button from "../../../../components/Button";
import TimePicker from "../../../../components/DatePicker/TimePicker";
import Select from "../../../../components/Select";
import XIcon from "../../../../assets/images/work-schedule/X-icon.svg";
import Icon from "../../../../components/Icon";
import Counter from "../../../../components/Counter";
import DeleteIcon from "../../../../assets/images/icon/delete-icon-01.svg";
import IconButton from "../../../../components/Button/IconButton";
import { DAY_TYPES } from "../../../../constants/WORK";

const ScheduleItem = ({
  counter,
  dayType,
  groupIndex,
  setDayList,
  onTypeChange,
  workStart,
  workEnd,
  restTimes,
  onWorkTimeChange,
  onRestTimeChange,
  handleAddRestTime,
  handleRemoveRestTime,
  handleRemoveDailySchedule,
  mode
}) => {
  return (
    <div className="daily-day-group">
      <Select
        name="dayType"
        className="day-type-select"
        value={dayType}
        list={DAY_TYPES}
        onChange={(e) => onTypeChange(e, groupIndex)}
      />
      {dayType === "workday" && (
        <div className="workday-container">
          <div className="workday-wrap">
            <label className="workday-label">근무</label>
            <div className="time-picker-wrap">
              <TimePicker
                isRange
                defaultValue={{ from: workStart, to: workEnd }}
                defaultPickerHour={{ from: 9, to: 18 }}
                onChange={(time) => {
                  onWorkTimeChange(time, groupIndex);
                }}
                disabled={mode === 'view'}
              />
            </div>
          </div>
          <div className="workday-wrap rest">
            <label className="workday-label">휴게</label>
            {!isEmpty(restTimes) &&
              restTimes.map((rest, idx) => (
                <React.Fragment key={idx}>
                  {idx > 0 && mode !== 'view' && (
                    <IconButton
                      icon={DeleteIcon}
                      onClick={() => handleRemoveRestTime(groupIndex, idx)}
                    />
                  )}
                  <div className="time-picker-wrap rest" key={idx}>
                    <TimePicker
                      isRange
                      defaultValue={{ from: rest.restStart, to: rest.restEnd }}
                      defaultPickerHour={{ from: 12, to: 13 }}
                      onChange={(time) => {
                        onRestTimeChange(time, groupIndex, idx);
                      }}
                      disabled={mode === 'view'}
                    />
                  </div>
                </React.Fragment>
              ))}
          </div>
        </div>
      )}
      {mode !== 'view' && (
        <Icon src={XIcon} className="margin-left-8" />
      )}
      <Counter
        className="work-schedule-form-counter"
        field={{
          unit: "일",
          handleChange: (data) => {
            setDayList((oldVal) =>
              [...oldVal].map((obj, idx) => {
                if (idx === groupIndex) {
                  return {
                    ...obj,
                    counter: data.counter,
                  };
                } else return obj;
              })
            );
          },
        }}
        min={1}
        data={counter}
        disabled={mode === 'view'}
      />
      {dayType === "workday" && mode !== 'view' && (
        <Button
          color="gray-line"
          label="휴게 추가"
          size="lg"
          className="margin-left-7"
          onClick={() => handleAddRestTime(groupIndex)}
        />
      )}
      {groupIndex > 0 && mode !== 'view' && (
        <IconButton
          className="margin-left-12"
          icon={DeleteIcon}
          onClick={() => handleRemoveDailySchedule(groupIndex)}
        />
      )}
    </div>
  );
};

const DailyWorkSchedule = ({ dayList, setDayList, mode }) => {
  const [allDay, setAllDay] = useState(null);
  const handleAddDailySchedule = () => {
    setDayList((oldVal) => [
      ...oldVal,
      {
        counter: 1,
        dayType: "workday",
        workStart: "09:00:00",
        workEnd: "18:00:00",
        restTimes: [
          {
            restStart: "12:00:00",
            restEnd: "13:00:00",
          },
        ],
      },
    ]);
  };

  useEffect(() => {
    if (dayList) {
      let count = 0;

      forEach(dayList, (day, idx) => {
        count += day.counter;
      });

      setAllDay(count);
    }
  }, [dayList]);

  const handleRemoveDailySchedule = (index) => {
    setDayList((oldVal) => [...oldVal].filter((day, idx) => idx !== index));
  };

  const handleOnChange = (e, dayName) => {
    const { name, value } = e.target;
    setDayList((oldVal) =>
      [...oldVal].map((obj, idx) => {
        if (idx === dayName) {
          return {
            ...obj,
            [name]: value,
          };
        } else return obj;
      })
    );
  };

  const handleOnChangeWorkTime = (t, dayName) => {
    const { from, to } = t;
    setDayList((oldVal) =>
      [...oldVal].map((obj, idx) => {
        if (idx === dayName) {
          return {
            ...obj,
            ...from ? { workStart: from } : {},
            ...to ? { workEnd: to } : {},
          };
        } else return obj;
      })
    );
  };

  const handleOnChangeRestTime = (t, dayName, restIdx) => {
    const { from, to } = t;
    setDayList((oldVal) =>
      [...oldVal].map((obj, idx) => {
        if (idx === dayName) {
          forEach(obj.restTimes, (rest, index) => {
            if (index === restIdx) {
              if (from) {
                rest.restStart = from;
              }
              if (to) {
                rest.restEnd = to;
              }
            }
          });
          return obj;
        } else return obj;
      })
    );
  };

  const handleAddrestTime = (index) => {
    setDayList((oldVal) =>
      [...oldVal].map((obj, idx) => {
        if (idx === index) {
          return {
            ...obj,
            restTimes: [
              ...obj.restTimes,
              { restStart: "12:00:00", restEnd: "13:00:00" },
            ],
          };
        } else return obj;
      })
    );
  };

  const handleRemoveRestTime = (dayName, idx) => {
    setDayList((oldVal) =>
      [...oldVal].map((obj, idx) => {
        if (idx === dayName) {
          forEach(obj.restTimes, (rest, index) => {
            if (index === idx) {
              obj.restTimes.splice(index, 1);
            }
          });
          return obj;
        } else return obj;
      })
    );
  };

  return (
    <div className="daily-workschedule-container">
      <label className="daily-workschedule-label">
        반복되는 일정 <span className="color-main-100">{allDay}</span>일
      </label>

      <div className="daily-schedule-wrap">
        {mode !== 'view' && (
          <Button
            className={"daily-schedule-add-btn"}
            color="gray-line"
            label="추가"
            onClick={handleAddDailySchedule}
          />
        )}

        {!isEmpty(dayList) &&
          dayList.map((day, index) => (
            <ScheduleItem
              {...day}
              key={index}
              groupIndex={index}
              setDayList={setDayList}
              onTypeChange={handleOnChange}
              onWorkTimeChange={handleOnChangeWorkTime}
              onRestTimeChange={handleOnChangeRestTime}
              handleAddRestTime={handleAddrestTime}
              handleRemoveRestTime={handleRemoveRestTime}
              handleRemoveDailySchedule={handleRemoveDailySchedule}
              mode={mode}
            />
          ))}
      </div>

    </div>
  );
};

export default DailyWorkSchedule;
